import http from "./httpService";
import URI from "urijs";

export function resetPassword(data) {
  const uri = new URI(`${process.env.REACT_APP_CLIENT_API_ENDPOINT}/user/password`);
  return http.post(uri.toString(), data, { headers: { "x-api-key": process.env.REACT_APP_API_KEY } });
}

export function createPasswordToken(data) {
  const uri = new URI(`${process.env.REACT_APP_CLIENT_API_ENDPOINT}/user/password/token`);
  return http.post(uri.toString(), data, { headers: { "x-api-key": process.env.REACT_APP_API_KEY } });
}
